const routes = [
  {
    path: "/",
    name: "生活",
    icon: require("@/assets/img/sh.png"),
    component: () => import("../views/life.vue"),
  },
  {
    path: "/work",
    name: "办公",
    icon: require("@/assets/img/bg.png"),
    component: () => import("../views/work.vue"),
  },
  {
    path: "/picture",
    name: "图片",
    icon: require("@/assets/img/tp.png"),
    component: () => import("../views/picture.vue"),
  },
  {
    path: "/other",
    name: "其他",
    icon: require("@/assets/img/qt.png"),
    component: () => import("../views/other.vue"),
  },
];

export default routes;
